// src/v3/actions/unlock.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var UnlockIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "UnlockIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.5 8.66667H9V6.44444C9 5.65862 9.31607 4.90498 9.87868 4.34931C10.4413 3.79365 11.2044 3.48148 12 3.48148C13.4409 3.48148 14.7375 4.5 15.015 5.85093C15.0562 6.04182 15.172 6.20894 15.3373 6.31596C15.5026 6.42298 15.7039 6.46126 15.8976 6.42246C16.0913 6.38367 16.2616 6.27094 16.3716 6.10878C16.4816 5.94663 16.5224 5.74815 16.485 5.55648C16.0612 3.49537 14.175 2 12 2C10.8069 2.00123 9.66303 2.46987 8.81939 3.3031C7.97575 4.13633 7.50124 5.26608 7.5 6.44444V8.66667H4.5C4.10218 8.66667 3.72064 8.82275 3.43934 9.10058C3.15804 9.37841 3 9.75523 3 10.1481V20.5185C3 20.9114 3.15804 21.2883 3.43934 21.5661C3.72064 21.8439 4.10218 22 4.5 22H19.5C19.8978 22 20.2794 21.8439 20.5607 21.5661C20.842 21.2883 21 20.9114 21 20.5185V10.1481C21 9.75523 20.842 9.37841 20.5607 9.10058C20.2794 8.82275 19.8978 8.66667 19.5 8.66667ZM19.5 20.5185H4.5V10.1481H19.5V20.5185Z"
  }
) });

export {
  UnlockIcon
};
